import React from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import headingStyles from "./Heading-tw-styles"
import getWidth from "../../../utils/gridWidth"
import Typography from "../../Generic/Typography"

const Heading = (props) => {
    const { heading, id, classes,styles }=props
    let headingStyle = ""
    if(styles)
    {
        headingStyle = headingStyles[styles]
    }
    else if (
        heading.styles &&
        headingStyles[heading.styles.trim()] !== undefined
    ) {
        headingStyle = headingStyles[heading.styles.trim()]
    }
    const widthClass = getWidth(heading.componentWidth)
    return (
        <Typography
            id={id}
            className={classNames(widthClass, headingStyle, classes)}
            component={
                heading?.headingName
                    ? heading?.headingName.toLowerCase()
                    : "div"
            }
            tabIndex='-1'
            >
           {heading.heading && heading.heading}
           </Typography>
    )
}
Heading.propTypes = {
    heading: PropTypes.oneOfType([PropTypes.object]),
    styles:PropTypes.string,
    id: PropTypes.string,
    classes: PropTypes.string
}
export default Heading
